/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it keep a history?`)
};

const es_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Guarda un historial?`)
};

const de_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird ein Verlauf gespeichert?`)
};

const nl_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Houdt hij een geschiedenis bij?`)
};

const fr_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garde-t-il un historique ?`)
};

const it_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiene una cronologia?`)
};

const pt_br2_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele guarda um histórico?`)
};

const pt_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda um histórico?`)
};

const ja_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履歴は保存されますか?`)
};

const zh_dice_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会保存投掷历史吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_q4", locale)
	if (locale === "en") return en_dice_faq_q4(inputs)
	if (locale === "es") return es_dice_faq_q4(inputs)
	if (locale === "de") return de_dice_faq_q4(inputs)
	if (locale === "nl") return nl_dice_faq_q4(inputs)
	if (locale === "fr") return fr_dice_faq_q4(inputs)
	if (locale === "it") return it_dice_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_q4(inputs)
	if (locale === "pt") return pt_dice_faq_q4(inputs)
	if (locale === "ja") return ja_dice_faq_q4(inputs)
	return zh_dice_faq_q4(inputs)
};